import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import LoadingIndication from '../../common/loading-indicator';

import ReferenceBox from '../../common/reference-box';
import Button from '../../common/button/button';
import articleTagsService from '../../../services/article-tags/article-tags';
import formattersService from '../../../services/formatters';

import './daily-news-section.css';

export default class DailyNewsSection extends Component {
  render() {
    let extraJSX;

    const { dailyNews } = this.props;

    if (!dailyNews) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      if (dailyNews.length === 0) {
        extraJSX = (
          <div>
            <p>There are no daily news</p>
          </div>
        );
      }
      else {
        extraJSX = (
          <div className='daily-news-container'>
            <div className='daily-news'>
              {
                dailyNews.map((dailyNewsItem, i) => 
                  <div key={ `daily-news-${i}` } className='little-grow-animation'>
                    <DailyNewsBox { ...dailyNewsItem } />
                  </div>
                )
              }
            </div>

            <Link to='/daily-news' title='Daily News'>
              <Button 
                label='Read More'
                isDark={ this.props.className !== 'dark' } />
            </Link>
          </div>
        );
      }
    }

    return (
      <section className={ `${ this.props.className } section-container daily-news-section-container` }>
        <h3 className='section-title'>
          Daily News
        </h3>

        { extraJSX }
      </section>
    );
  }
}

function DailyNewsBox(props) { 
  const { tags, internalUrlId, imgUrl, date, } = props;

  const relevantTags = articleTagsService.getRelevantRecommendationsTags(tags);
  const link = `/daily-news/${ internalUrlId }`;

  return (
    <div className='daily-news-box little-grow-animation'>
      <ReferenceBox 
        { ...props }
        link={ link }
        imgSrc={ imgUrl }
        postTime={ formattersService.formatDate(date) }
        tags={ relevantTags } />
    </div>
  );
}